const letterValues = {
    'A': 1, 'B': 2, 'C': 3, 'D': 4, 'E': 5, 'F': 6, 'G': 7, 'H': 8,
    'J': 1, 'K': 2, 'L': 3, 'M': 4, 'N': 5, 'P': 7, 'R': 9,
    'S': 2, 'T': 3, 'U': 4, 'V': 5, 'W': 6, 'X': 7, 'Y': 8, 'Z': 9,
    '0': 0, '1': 1, '2': 2, '3': 3, '4': 4, '5': 5, '6': 6, '7': 7, '8': 8, '9': 9
};
const weights = [8, 7, 6, 5, 4, 3, 2, 10, 0, 9, 8, 7, 6, 5, 4, 3, 2];

const validateVinChecksum = (vin) => {
    if (vin.length !== 17) {
        return false;
    }

    const upperVin = vin.toUpperCase();
    let val = 0;

    for (let idx = 0; idx < 17; idx++) {
        const item = upperVin[idx];
        const pos = letterValues[item];
        if (pos === undefined) {
            return false;
        }
        val += pos * weights[idx];
    }

    const checksum = val % 11;
    const checksumChar = checksum < 10 ? checksum.toString() : 'X';

    return upperVin[8] === checksumChar;
};

document.addEventListener('DOMContentLoaded', function () {
    let vinInputTimeout;

    document.querySelectorAll('.find-vin__form.vin .find-vin__input').forEach((input) => {
        input.addEventListener('input', function () {
            const form = input.closest('form');
            let vin = input.value.trim().replace(/[^a-zA-Z0-9]/g, '');

            clearTimeout(vinInputTimeout);

            if (vin.length !== 17) {
                return;
            }

            vinInputTimeout = setTimeout(() => {
                if (validateVinChecksum(vin)) {
                    input.value = vin;
                    submitForm(vin, form);
                }
            }, 150);
        });
    });

    document.querySelectorAll('.find-vin__form.vin').forEach((form) => {
        form.addEventListener('submit', function (evt) {
            evt.preventDefault();

            const vinField = form.querySelector('.find-vin__input');
            let vin = vinField.value.trim();
            const reg = /^[a-zA-Z0-9]*$/;

            if (5 <= vin.length && vin.length <= 17 && reg.test(vin)) {
                submitForm(vin, form);
            } else {
                showError(form, 'Please, ensure that your VIN is in proper format. 5 - 17 digits.');
            }
        });
    });

    function startLoading(form) {
        form.querySelector('.find-vin__check-btn').classList.add('loader');
        form.querySelector('.find-vin__check-btn').disabled = true;
    }

    function stopLoading(form) {
        form.querySelector('.find-vin__check-btn').classList.remove('loader');
        form.querySelector('.find-vin__check-btn').disabled = false;
    }

    function submitForm(vin, form) {
        if (window.onDh ?? 0) {
            $('#dispute-modal').modal({show: true});
            return;
        }

        startLoading(form);
        let precheckLink = window.checkOutRoute + '/' + vin;

        window.location.href = precheckLink;

        setTimeout(() => {
            stopLoading(form);
        }, 1500);
    }

    function showError(form, message) {
        const errorMessage = form.querySelector('.find-vin__error-msg');

        form.classList.add('invalid');
        errorMessage.textContent = message;

        setTimeout(() => {
            form.classList.remove('invalid');
        }, 2000);
    }
});
